// ISP-9999 minimal-signup door: the backend's SignupSerializer.country is a
// required 2-letter code (home/api/v1/serializers.py), but Gordon's decision
// removes the visible country picker entirely — the door only asks for
// Email / Password-or-social / Display Name / 18+. We still owe the backend
// SOME value, so it's derived silently from the browser locale's region
// subtag (e.g. "en-GB" -> "GB"), which is populated by the OS/device locale
// on every mainstream browser. No network call, no picker, no state.
export const DEFAULT_COUNTRY_CODE = "US";

export function deriveCountryCode(nav = typeof navigator !== "undefined" ? navigator : undefined) {
  try {
    const locales = nav?.languages?.length ? nav.languages : [nav?.language].filter(Boolean);
    for (const locale of locales) {
      const region = String(locale).split(/[-_]/)[1];
      if (region && /^[a-zA-Z]{2}$/.test(region)) {
        return region.toUpperCase();
      }
    }
  } catch (e) {
    // fall through to default
  }
  return DEFAULT_COUNTRY_CODE;
}
